<template>
  <div>
    <v-dialog v-if="popup" v-model="show" max-width="950" persistent>
      <v-card>
        <v-card-title class="headline">{{ question }}</v-card-title>
        <v-card-text>
          <div class="row">
            <div v-for="option in options" v-bind:key="option.value"
                 :style="{'background': option.color}"
                 :class="['button', 'row', isSelected(option.value)]"
                 @click="select(option.value)">
              <v-icon size='50px' dark class="icon">{{ option.icon }}</v-icon>
              <div class="button-group">{{ option.name }}</div>
              <div class="button-description">{{ option.description }}</div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card v-else>
      <v-card-title class="headline">{{ question }}</v-card-title>
      <v-card-text>
        <div class="row">
          <div v-for="option in options" v-bind:key="option.value"
               :style="{'background': option.color}"
               :class="['button', 'row', isSelected(option.value)]"
               @click="select(option.value)">
            <v-icon size='50px' dark class="icon">{{ option.icon }}</v-icon>
            <div class="button-group">{{ option.name }}</div>
            <div class="button-description">{{ option.description }}</div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "StaffQuestion",
  permissions: ["Modify Staff Feedback"],
  components: {},
  props: {
    popup: {
      type: Boolean,
      default: false,
    }
  },
  computed: {},
  mounted() {
    this.$BwfApi.get("staff-feedback").then((response) => {
      if (response) {
        this.rating = response.response
      }
    })
    if (this.popup) {
      this.$BwfApi.get("user-settings").then(settings => {
        const lastAnswered = settings.staff_question_last_answered
        if (!lastAnswered) {
          this.show = true
        } else {
          const daysSince = (Date.now() - new Date(lastAnswered).getTime()) / (1000 * 60 * 60 * 24)
          if (daysSince > 7) {
            this.show = true
          }
        }
      })
    }
  },
  data() {
    return {
      title: "Staff Question",
      showTitle: false,
      editable: false,
      isReady: true,
      valid: true,
      question: "How are you feeling about your workload?",
      rating: 0,
      show: false,
      options: [
        {
          name: "Overwhelmingly under-pressured",
          description: "I feel extremely inactive / unengaged",
          value: 1,
          icon: "mdi-emoticon-angry-outline",
          color: "red"
        },
        {
          name: "Significantly under-pressured",
          description: "I often look for things to do and need a lot more",
          value: 2,
          icon: "mdi-emoticon-sad-outline",
          color: "orange"
        },
        {
          name: "Moderately under-pressured",
          description: "I have spare capacity and could do a bit more",
          value: 3,
          icon: "mdi-emoticon-neutral-outline",
          color: "#8cc42b"
        },
        {
          name: "Just right",
          description: "I feel balanced and productive",
          value: 4,
          icon: "mdi-emoticon-happy-outline",
          color: "green"
        },
        {
          name: "Moderately pressured",
          description: "I feel very busy but can manage",
          value: 5,
          icon: "mdi-emoticon-neutral-outline",
          color: "#8cc42b"
        },
        {
          name: "Significantly pressured",
          description: "I'm struggling to keep up",
          value: 6,
          icon: "mdi-emoticon-sad-outline",
          color: "orange"
        },
        {
          name: "Overwhelmingly pressured",
          description: "I feel unable to cope",
          value: 7,
          icon: "mdi-emoticon-angry-outline",
          color: "red"
        }
      ],
    }
  },
  methods: {
    select(val) {
      this.rating = val
      this.$BwfApi.post("staff-feedback", {question: 1, response: val}).then(() => {
        this.$notify.toast("Saved")
        this.$BwfApi.post("user-settings", {
          setting_name: "staff_question_last_answered",
          setting_value: new Date().toISOString()
        })
        if (this.popup) {
          this.show = false
        }
      })
    },
    isSelected(val) {
      return val === this.rating ? "selected" : ""
    }
  }
}

</script>

<style scoped>
.button {
  width: 150px;
  height: 190px;
  display: inline-block;
  color: white;
  padding: 10px;
  text-align: center;
  border-radius: 10px;
  margin: 5px;
  opacity: 0.7;
  cursor: pointer;
  font-size: larger;
}

.icon {
  padding-bottom: 10px;
}

.selected {
  box-shadow: 10px 10px 20px grey;
  opacity: 1;
}

.button-description {
  font-size: small;
  padding-top: 10px;
}
</style>
